import { localisedValue } from "utils"

const occupationTransformer = response => {
  return response.map(e => ({
    ...e,
    key: e.key,
    label: localisedValue({ object: e, key: "name" }),
    value: e.id.toString(),
    id: e.id,
  }))
}

export default occupationTransformer
